define('js/radar',['require','exports','module','Radar','../../common/js/xPageId','../../common/js/ga'],function (require, exports, module) {
    var Radar = require('Radar');
    var xPageId = require('../../common/js/xPageId');
    var GA = require('../../common/js/ga');

    Radar.domain = 'https://xray.mail.ru';

    var radar = function radar(data, group) {
        var radar = new Radar('cloud', group || 'main-page');
        var metric = data.category + '_' + data.action;

        if (data.label) {
            metric += '_' + data.label;
        }

        radar.param('x-page-id', xPageId);

        GA.getUserId().then(function (clientId) {
            radar.param('clientId', clientId);
            radar.add(metric).send();
        });
    };

    function iReplacer(i) {
        return i.replace(/[^a-zA-Z0-9-_]/gi, '-');
    }

    radar.ga = function (category, action, label) {
        if (typeof category !== 'string') {
            var params = category;

            category = params.category;
            action = params.action;
            label = params.label;
        }

        var gaCategoryPrefix = window.gaCategoryPrefix || 'main-page';

        category = gaCategoryPrefix + '_' + category;

        var data = {
            category: iReplacer(category),
            action: iReplacer(action)
        };

        if (label) {
            data.label = iReplacer(label);
        }

        window.console &&
            window.console.info &&
            window.console.info('DWH GA: category - "' + category + '", action - "' + action + '", label - "' + label + '"');

        radar(
            {
                category: iReplacer(category),
                action: iReplacer(action),
            },
            'web-analytics'
        );

        window.gtag('event', action, {
            event_category: category,
            event_label: label,
        });
    };

    module.exports = radar;
});

